// Expands a link's touch target to the 44px minimum without changing its layout.
//
// Sizing the text itself would add ~25px of height to every row, which on a dense
// list costs a lot of vertical space. An absolutely-positioned overlay centred on
// the text gives the same hit area for free.
export const TAP_TARGET = {
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    height: 44,
    transform: 'translateY(-50%)',
  },
};
